import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import { useCallback, useState } from "react";

const MarkerWithInfoWindow = ({ position, title, onViewImageClick }) => {
  const [markerRef, marker] = useAdvancedMarkerRef();

  const [infoWindowShown, setInfoWindowShown] = useState(false);

  const handleMarkerClick = useCallback(
    () => setInfoWindowShown((isShown) => !isShown),
    []
  );
  const handleClose = useCallback(() => setInfoWindowShown(false), []);
  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        onClick={handleMarkerClick}
      />

      {infoWindowShown && (
        <InfoWindow anchor={marker} onClose={handleClose}>
          <div>
            <p className="maker-info-title">{title}</p>
            <p className="info-lat-lng">
              {position && <>
                (Lat: {parseFloat(position.lat() || 0).toFixed(6)}, Lon: {parseFloat(position.lng() || 0).toFixed(6)})
              </>}
            </p>
            <p className="view-image" onClick={onViewImageClick}>
              View Image
            </p>
          </div>
        </InfoWindow>
      )}
      
    </>
  );
};
export default MarkerWithInfoWindow;
